/**
 * Checks if a certain type of cookie is accepted (necessary, functional, analytical or personalized)
 */
export function cookiesAccepted(name) {
    // If the user has not accepted any cookies return false
    const acceptedLevels = getJsonCookie('jet-consent-courierweb');
    if (acceptedLevels === null) {
        return false;
    }

    return Array.isArray(acceptedLevels) && acceptedLevels.includes(name);
}

export function getCookie(name, defaultValue = null) {
    let cookie = document.cookie.split('; ').find((item) => item.startsWith(name + '='));

    if (cookie) {
        return cookie.replace(name + '=', '');
    }

    return defaultValue;
}

export function getJsonCookie(name, defaultValue = null) {
    let cookie = getCookie(name);

    if (cookie) {
        try {
            return JSON.parse(cookie);
        } catch {
            /* empty */
        }

        try {
            return JSON.parse(decodeURIComponent(cookie));
        } catch {
            /* empty */
        }

        console.error('Error parsing cookie', cookie, name, defaultValue);
        return defaultValue;
    }

    return defaultValue;
}

export function setCookie({ name, value, domain }) {
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 90);

    let cookie = name + '=' + value + ';path=/;expires=' + expiryDate.toUTCString();
    cookie += window.location.protocol === 'https:' ? ';secure' : '';
    if (domain) {
        cookie += '; domain=' + domain;
    }
    document.cookie = cookie;
}

export function setJsonCookie({ name, value, domain }) {
    // Encode JSON values to ensure safe cross-system transfer
    setCookie({ name, value: encodeURIComponent(JSON.stringify(value)), domain });
}

export function removeCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}
